import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=756dcfbf&scoped=true&"
import script from "./ProfileData.vue?vue&type=script&lang=js&"
export * from "./ProfileData.vue?vue&type=script&lang=js&"
import style0 from "./ProfileData.vue?vue&type=style&index=0&id=756dcfbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756dcfbf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,Dropdown: require('/home/bitrix/frontend/components/form/Dropdown.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
